var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle-select',{attrs:{"options":_vm.fontOptions,"aria-value":"font"},model:{value:(_vm.selectedFont),callback:function ($$v) {_vm.selectedFont=$$v},expression:"selectedFont"}},[_vm._v("\n  Ab\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }